import { i as e } from "./errors-BJxlOkXf.js";
//#region src/shell/formSessionGuard.ts
function t(t, n = () => e("STALE")) {
	if (t.signal?.aborted || t.isCurrent?.() === !1) throw n();
}
function n(n) {
	let r = () => {
		if (t(n), n.isReady?.() === !1) throw e("NOT_READY");
	};
	return Object.freeze({
		signal: n.signal,
		assertCurrent: r,
		async run(e) {
			r();
			let t = await e();
			return r(), t;
		}
	});
}
async function r(t, n, r) {
	if (!Number.isFinite(n.remainingMs) || n.remainingMs <= 0) throw e(r);
	if (n.signal.aborted) throw e("STALE");
	let i = new AbortController(), a = AbortSignal.any([n.signal, i.signal]), o, s = () => void 0, c = new Promise((t, c) => {
		let l = () => c(e("STALE"));
		a.addEventListener("abort", l, { once: !0 }), s = () => a.removeEventListener("abort", l), o = setTimeout(() => {
			c(e(r)), i.abort();
		}, n.remainingMs);
	}), l = Promise.resolve().then(() => {
		if (a.aborted) throw e("STALE");
		return t(Object.freeze({
			signal: a,
			remainingMs: n.remainingMs
		}));
	});
	l.catch(() => void 0);
	try {
		let t = await Promise.race([l, c]);
		if (a.aborted) throw e("STALE");
		return t;
	} finally {
		o !== void 0 && clearTimeout(o), s();
	}
}
//#endregion
export { n, r, t };
